/**
 * The brand's "hu" in italics: every standalone "hu" in the page's text (any
 * case, not inside a word) is wrapped in <em>, once, on DOM ready. In a flex
 * container the <em> becomes a flex item of its own and the spaces around it
 * collapse, so there it gets a non-breaking space on each side.
 *
 * It replaces the version committed on live in 98b3389d7, which did the same
 * through innerHTML and a lookbehind regex:
 *  - innerHTML re-parsed the page's text as markup, so a "<" in CMS copy became
 *    a tag. Here the text stays text: the node is split with DOM calls.
 *  - `(?<!\w)` written as a regex literal is a SyntaxError for the whole bundle
 *    on Safari before 16.4, not just for this feature. Here the word boundary
 *    is checked by hand.
 *  - it rewrote every text node under <body>, the webapps' too. React throws
 *    NotFoundError when a text node it owns is replaced (Sentry HU-BOL-WEB-A,
 *    the reason the BOL mount carries translate="no"), so their mounts are
 *    skipped, like scripts, form controls, SVG and text already in italics.
 */
const SKIPPED = [
    'script', 'style', 'noscript', 'template', 'textarea', 'option', 'svg',
    'em', 'i', '[contenteditable]',
    '[data-hubol]', '#HuBOL', '#root', // webapp mounts: BOL, Centro Assistenza, booking management
].join(', ');

const WORD = /\w/;

export function initHuItalics() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
            if (!huPositions(node.nodeValue).length || node.parentElement.closest(SKIPPED)) {
                return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_ACCEPT;
        },
    });

    // Collected first: replacing a node while walking would move the walker.
    const nodes = [];
    while (walker.nextNode()) {
        nodes.push(walker.currentNode);
    }

    nodes.forEach(italicise);
}

function italicise(node) {
    const text = node.nodeValue;
    const display = window.getComputedStyle(node.parentElement).display;
    const padding = display === 'flex' || display === 'inline-flex' ? ' ' : '';
    const parts = [];
    let from = 0;

    huPositions(text).forEach((at) => {
        const em = document.createElement('em');
        em.textContent = text.slice(at, at + 2);
        parts.push(text.slice(from, at) + padding, em, padding);
        from = at + 2;
    });
    parts.push(text.slice(from));

    const fragment = document.createDocumentFragment();
    fragment.append(...parts.filter((part) => part !== ''));
    node.parentNode.replaceChild(fragment, node);
}

/**
 * Where "hu" starts as a word of its own: no word character (\w, as before)
 * right before or right after it.
 */
function huPositions(text) {
    const positions = [];
    const pattern = /hu/gi;
    let match;

    while ((match = pattern.exec(text))) {
        const at = match.index;
        if (!WORD.test(text.charAt(at - 1)) && !WORD.test(text.charAt(at + 2))) {
            positions.push(at);
        }
    }

    return positions;
}
